import './todos.css';
import { useTodos } from '../../../hooks/useTodos';
import { useEffect, useMemo, useState } from 'react';

const getRemainingDaysClass = (date) => {
    const today = new Date();
    const targetDate = new Date(date);
    const diffTime = targetDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 2) return 'todoUrgent';
    if (diffDays < 7) return 'todoWarning';
    return 'todoNormal';
};

function Todos() {
    const { fetchAllTodos, allTodos, updateTodo } = useTodos();
    const [showCompletedTodos, setShowCompletedTodos] = useState(false);

    useEffect(() => {
        fetchAllTodos();
    }, []);

    const handleToggleTodo = async (todoId, isDone) => {
        await updateTodo(todoId, { done: isDone });
    };

    const todosByPrio = useMemo(() => {
        const groupedTodos = {
            1: [],
            2: [],
            3: []
        };

        const visibleTodos = showCompletedTodos
            ? (allTodos || [])
            : (allTodos || []).filter((todo) => !todo.done);

        visibleTodos.forEach((todo) => {
            const prio = Number(todo.prio || 3);
            if (groupedTodos[prio]) {
                groupedTodos[prio].push(todo);
            }
        });

        Object.keys(groupedTodos).forEach((prio) => {
            groupedTodos[prio].sort((a, b) => new Date(a.date) - new Date(b.date));
        });

        return groupedTodos;
    }, [allTodos, showCompletedTodos]);

    return (
        <div className='pageContainer todosPage'>
            <div className='todosHeader'>
                <h1 className='todosTitle'>Todos</h1>
                {allTodos.some((todo) => todo.done) && (
                    <button
                        type='button'
                        className='todosToggleButton'
                        onClick={() => setShowCompletedTodos((prev) => !prev)}
                    >
                        {showCompletedTodos ? 'Erledigte Todos ausblenden' : 'Erledigte Todos anzeigen'}
                    </button>
                )}
            </div>
            <div className='todosTableWrapper'>
                <table className='todosTable'>
                    <thead>
                        <tr>
                            <th>Prio 1</th>
                            <th>Prio 2</th>
                            <th>Prio 3</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {[1, 2, 3].map((prio) => (
                                <td key={prio}>
                                    <div className='todosColumn'>
                                        <div className='todosColumnTitle'>Prio {prio}</div>
                                        {todosByPrio[prio].length > 0 ? (
                                            <ul className='todosList'>
                                                {todosByPrio[prio].map((todo) => (
                                                    <li key={todo._id} className='todoItem'>
                                                        <div className='todoItemHeader'>
                                                            <input
                                                                type='checkbox'
                                                                checked={todo.done || false}
                                                                onChange={() => handleToggleTodo(todo._id, !todo.done)}
                                                                className='todoCheckbox'
                                                            />
                                                            <span className='todoDescription'>{todo.description}</span>
                                                        </div>
                                                        <span className='todoMeta'>
                                                            Frist: {todo.formattedDate} <br />
                                                            Kunde: {todo.customerName}
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className='todosEmpty'>Keine Todos</p>
                                        )}
                                    </div>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Todos;